import { parseQueryArguments } from '@/shared'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, parseQuery, patchData, postData } from '../utils/db'
import { TableExportRequestType } from '@/shared/types/export'

export type TableViewDataRequestType = TableListRequestType & {
    outTableId: string,
    inTableId: string,
    fileId: string,
    name: string,
    project: string,
    outTemplateId: string,
    data: any,
}
export type TableExportCancelType = {
    project: string,
    jobId: string,
}

export default class ConverterListModel implements ITableListModel<any> {
    constructor() { }

    public async list({
        mode = TABLE_REQUEST_MODE.PAGINATION,
        project,
        page = 0,
        limit = 10,
        q = '',
        query = {},
    }: TableListRequestType) {
        let strQuery = parseQueryArguments(`page=${page}&limit=${limit}`, arguments)
        if (q) strQuery += '&q=' + encodeURI(q)
        if (mode == TABLE_REQUEST_MODE.POSITION) {
            strQuery += '&mode=position'
        }
        strQuery = parseQuery(strQuery, query)
        return await getData(`/export/${project}?${strQuery}`)
    }

    public async read(project: string, id: string) {
        return await getData(`/export/${project}/${id}`)
    }

    public async create(project: string, data: any) {
        return await postData(`/export/${project}`, data)
    }

    public async update(project: string, id: string, data: any) {
        return await patchData(`/export/${project}/${id}`, data)
    }

    public async delete(project: string, id: string) {
        return await deleteData(`/export/${project}/${id}`)
    }

    public async count(project: string) {
        return await countData(`/export/${project}/count`)
    }

    public async viewData({
        project,
        outTableId,
        inTableId,
        fileId,
        q = '',
        mode = TABLE_REQUEST_MODE.PAGINATION,
        page = 0,
        limit = 10,
        query = {},
    }: TableViewDataRequestType) {
        let strQuery = `page=${page}&limit=${limit}&outTableId=${outTableId}`
        if (q) strQuery += '&q=' + encodeURI(q)

        if (mode == TABLE_REQUEST_MODE.POSITION) {
            strQuery += '&mode=position'
        }
        strQuery = parseQuery(strQuery, query)
        return await getData(`/export/${project}/view/${inTableId}/${fileId}?${strQuery}`)
    }

    public async export({ project, data }: TableExportRequestType) {
        return await postData(`/export/${project}/excel`, { project, data })
    }

    public async cancel({ project, jobId }: TableExportCancelType) {
        return await postData(`/export/${project}/excel/cancel/${jobId}`, {})
    }

}
